import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-开票管理",
  "use": "icon-开票管理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-开票管理\"><defs><style type=\"text/css\"></style></defs><path d=\"M944 382.56h-138.24v-64H880v-160H144v160h77.6v64H80V94.72h864v287.84z\" p-id=\"1200\" fill=\"#ffffff\" /><path d=\"M512 929.28l-153.6-64L176 922.24V222.72h672v699.52L665.6 864z m-150.4-132.64l150.4 64 150.4-64 121.6 38.4V286.72H240v548.32z\" p-id=\"1201\" fill=\"#ffffff\" /><path d=\"M343.2 398.72h337.6v64h-337.6zM343.2 542.72h337.6v64h-337.6z\" p-id=\"1202\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/开票管理.svg
// module id = RCBi
// module chunks = 27